import React, {useState} from 'react';
import {Card, Checkbox, Input, Modal, Radio, Space, Table, Tag} from 'antd';
import {useBoolean, useMount} from 'react-use';
import {UserApi, UserDto, UserRole} from '../../scaffold';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import ImportUserExcel from '../../components/user/ImportExcel';
import Text from 'antd/lib/typography/Text';
import Flex from '../../components/Flex';
import ImportUserStatusExcel from '../../components/user/ImportStatusExcel';

const {confirm} = Modal;

export default function ManageUserStatusPage() {
  const [role, setRole] = useState<UserRole>(UserRole.教师);
  const [keyword, setKeyword] = useState('');
  const listState = useOpenApiFpRequest(UserApi, UserApi.prototype.userListGet);

  function refresh() {
    listState.requestSync({});
  }
  useMount(() => {
    refresh();
  });
  const displayRows =
    listState.data
      ?.filter(i => i.role === UserRole.学生)
      .filter(i => {
        if (!keyword) return true;
        return i.name?.includes(keyword);
      }) || [];

  return (
    <Card title={'学业完成情况'}>
      <Flex className={'m-b-10'} justify={'space-between'} align={'center'}>
        <Space className={'m-b-10'}>
          <Input value={keyword} onChange={e => setKeyword(e.target.value)} placeholder={'输入关键词检索'} />
        </Space>
        <ImportUserStatusExcel refresh={refresh} />
      </Flex>
      <Table rowKey={'id'} dataSource={displayRows} size={'small'} bordered loading={listState.loading}>
        <Table.Column<UserDto>
          title={'姓名'}
          dataIndex={'name'}
          render={(_, item) => (
            <div>
              <Text className={'m-r-5'} strong>
                {item.name}
              </Text>
            </div>
          )}
        />
        <Table.Column<UserDto> title={'学号'} dataIndex={'username'} />
        <Table.Column<UserDto> title={'论文开题报告'} dataIndex={'thesisStartReport'} />
        <Table.Column<UserDto> title={'论文中期检查'} dataIndex={'thesisMiddleReport'} />
        <Table.Column<UserDto> title={'是否可论文送审'} dataIndex={'thesisReady'} />
        <Table.Column<UserDto> title={'过程管理是否合格'} dataIndex={'thesisOk'} />
        <Table.Column<UserDto> title={'GPA(当前/已修/要求)'} dataIndex={'gpa'} />
        <Table.Column<UserDto> title={'操作'} />
      </Table>
    </Card>
  );
}
